import { CanvasServiceImpl } from '@/modules/canvas/services/Canvas/CanvasServiceImpl';
import { ICanvasService } from '@/modules/canvas/services/Canvas/ICanvasService';
import { useCanvasStore } from '@/modules/canvas/store';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useLodStore } from '@/modules/lod/useLodStore';
import { useVehicleStore } from '@/modules/vehicles/store/useVehicleStore';

export class CanvasServiceFactory {
  private static instance: CanvasServiceFactory | null = null;
  private canvasStore: typeof useCanvasStore;
  private lodStore: typeof useLodStore;
  private appStore: typeof useAppStore;
  private floorplanDesignStore: typeof useFloorplanDesignStore;
  private vehicleStore: typeof useVehicleStore;

  public static initialize(
    canvasStore: typeof useCanvasStore,
    lodStore: typeof useLodStore,
    appStore: typeof useAppStore,
    floorplanDesignStore: typeof useFloorplanDesignStore,
    vehicleStore: typeof useVehicleStore,
  ) {
    CanvasServiceFactory.instance = new CanvasServiceFactory(
      canvasStore,
      lodStore,
      appStore,
      floorplanDesignStore,
      vehicleStore,
    );
  }

  public static getInstance() {
    if (CanvasServiceFactory.instance === null) {
      throw new Error(
        'CanvasServiceFactory not yet initialized. Call CanvasServiceFactory.initialize() first.',
      );
    }
    return CanvasServiceFactory.instance;
  }

  private constructor(
    canvasStore: typeof useCanvasStore,
    lodStore: typeof useLodStore,
    appStore: typeof useAppStore,
    floorplanDesignStore: typeof useFloorplanDesignStore,
    vehicleStore: typeof useVehicleStore,
  ) {
    this.canvasStore = canvasStore;
    this.lodStore = lodStore;
    this.appStore = appStore;
    this.floorplanDesignStore = floorplanDesignStore;
    this.vehicleStore = vehicleStore;
  }

  public createCanvasService(): ICanvasService {
    return new CanvasServiceImpl(
      this.canvasStore,
      this.lodStore,
      this.appStore,
      this.floorplanDesignStore,
      this.vehicleStore,
    );
  }
}
